import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import cx from 'classnames';
export const getIconClasses = (icon, isFixedWidth) => {
  const parts = icon.replace(/_/g, '-').split(' ');
  if (parts.length === 1) {
    parts.unshift(materialIconsDefaultType);
  }
  const iconClasses = _mapInstanceProperty(parts).call(parts, (part, index) => index === 0 || isMiIcon(part) ? part : "".concat(materialIconsIconPrefix).concat(part)).join(' ');
  if (isFixedWidth) return cx(iconClasses, fixedWidthMaterialClassName);
  return iconClasses;
};
function isMiIcon(icon) {
  return _startsWithInstanceProperty(icon).call(icon, materialIconsIconPrefix);
}
const materialIconsDefaultType = 'mir';
const fixedWidthMaterialClassName = 'mi-fw';
const materialIconsIconPrefix = 'mi-';